import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, mapTo, map } from 'rxjs/operators';
import { AppConfig } from '../constants';


@Injectable({ providedIn: 'root' })
export class RestClientService {
    constructor(private http: HttpClient) { }
    public Post<requestBody, requestResponse>(url: string, arg: requestBody): Observable<requestResponse> {
        const endPoint = environment.apiUrl + url;



        return this.http.post<requestResponse>(`${endPoint}`, arg, { headers: new HttpHeaders({ Caller: AppConfig.WebAppHttpHeader }) })
            .pipe
            (
                map((response: requestResponse) => response),
                catchError(error => {
                    console.log(error.error);
                    return throwError(error.error as requestResponse);
                })
            );
    }
}
